import React, { Component } from "react";
import { Icon, Button, message, Modal, Row } from "antd";
import PDF from "./images/new/pdf.svg";
import SendBFileModal from "./send-bfile-modal";
import SaveForLaterModal from "./save-for-later-modal";
import SendFollowUpModal from "./send-follow-up-modal";
import NoAnswerModal from "./no-answer-modal";
import NoSaleArchiveModal from "./no-sale-archive-modal";
import DataHandler from "../../../utils/DataHandler";
import CustomerExist from "./customer-exist";
import { Translate } from "react-translated";
import F from "../../../Functions";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { HandlePrint } from "../../../components/print-pdf/printLogic";
import PrintableContent from "../../../components/print-pdf/PrintableContent";
import { NEW_BFILE, PROFILE_SAVED_FOR_LATER, RENEWAL, BFILE_HAS_BEEN_UPDATED, PLEASE_FILL_ALL_REQUIRED_FIELD, PHONE_NUMBER_INVALID, MANDATORY_FIELDS_ERROR, DISCARD_BFILE_CONFIRMATION, NO, YES, DISCARD_UPDATION_CONFIRMATION, MANDATORY_FIELDS_ERROR_UPDATION, BFILE_COMPLETED_SUCCESSFULLY } from "../../../utils/Constants";
import { useBoundStore } from "../../../store/useBoundStore";

class WizardFooter extends Component {
  printRef = React.createRef();
  state = {
    show_send_bfile_modal: false,
    show_save_for_later_modal: false,
    show_no_sale_archive: false,
    show_send_follow_up_modal: false,
    showConfirmationModal: false,
    financial_users: [],
    onboarding_users: [],
    show_print_modal: false,
    isWizardValueUpdated: false,
  };

  // agency_owner_details = {
  //   carrier: this.props.wizard.carrier
  // }

  componentDidMount() {
    // check is Quick FollowUp Call From BFile Action set to Temp singleton class
    if (DataHandler.isQuickFollowUpCallFromBFileActionTemp()) {
      // reset singleton class state variable
      DataHandler.setQuickFollowUpCallFromBFileActionTemp(false);

      // show B File Modal Automatically If comes here from Quick `FollowUp Call` B File Action
      // setTimeout(() => this.showSendBfileModal(), 1000);
      setTimeout(() => this.checkDuplicateCustomer(true), 1000);
    }
  }


  toggleRAC() {
    window.document.querySelector("body").classList.toggle("show_rac");
  }

  checkDuplicateCustomer(isSendBFile) {
    message.destroy();

    const { wizard, updateLoadingState, updateField, save } = this.props;
    const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(wizard.phone);

    if (updateLoadingState) updateLoadingState(true);

    const historyState = this.props.history.location;
    const user = this.props.user

    axios.post(`/api/check_customer_exist${historyState.state && historyState.state.user_type && historyState.state.user_type === 'BOBADMIN' && `?user_type=${historyState.state.user_type}` || ''}`, {
      phone: phoneNumberFormatterRemoved,
      skip_child: true, // only parent will consider
      agency_id: wizard.agency_id
    })
      .then((res) => {
        if (updateLoadingState) updateLoadingState(false);

        if (!res.data || typeof res.data.exist === "undefined") {
          message.error("Unexpected response from server.");
          return;
        }

        if (!isSendBFile) {
          // If "Update B File"
          if (res.data.exist && wizard.id !== res.data.bfile_id && wizard.parent_id !== res.data.bfile_id) {
            message.error("Phone number already exists in the system. Please add a unique number.");
          } else {
            let note_action = "Update B File";
            save((bfile) => {
              axios.post("/api/bfile_notes", {
                bfile_id: bfile.id,
                note: "Update B File",
                user_id: user.id,
                action: note_action,
                type_of_call: wizard.type_of_call,
                sub_type_of_call: wizard.sub_type_of_call
              }).finally(() => {
                if (updateLoadingState) updateLoadingState(false);
              });
            });
          }
        } else {
          // If "Send B File"          
          if (res.data.exist && wizard.id !== res.data.bfile_id && wizard.parent_id !== res.data.bfile_id) {
            DataHandler.setSendingBFileModalState(true);
            updateField("show_modal_customer_exist", true);
            updateField("modal_customer_bfile_id", res.data.bfile_id);
          } else {
            updateField("show_modal_customer_exist", false);
            updateField("modal_customer_bfile_id", null);
            this.showSendBfileModal();
          }
        }
      })
      .catch((error) => {
        if (updateLoadingState) updateLoadingState(false);
        F.showAndHandleServerError(error);
      })
      .finally(() => {
        if (updateLoadingState) updateLoadingState(false);
      });
  }


  handleCompleteClick = () => {
    const { wizard } = this.props;
    if (wizard.agency_info.is_opportunity == 0) {
      message.success(BFILE_COMPLETED_SUCCESSFULLY);
      this.props.history.push('/dashboard')
    } else {
      this.checkWizard();
    }
  }


  checkWizard() {
    const { wizard, user, save } = this.props;
    const errors = [];

    // reset notification
    message.destroy();

    if (wizard.first_name === "") {
      errors.push("First Name is Mandatory.");
    }
    if (wizard.last_name === "") {
      errors.push("Last Name is Mandatory.");
    }
    if (wizard.phone === "") {
      errors.push("Phone is Mandatory.");
    }

    // validate regix
    if (!F.validatePhoneRegix(wizard.phone)) {
      errors.push("Phone is Invalid");
    }

    // if ((wizard.dob_mm === "" || wizard.dob_yyyy === "") && wizard.carrier !== "Country Financial") {
    //   errors.push("DOB is Mandatory.");
    // }

    // validate regix
    if (
      wizard.phone2 != null &&
      wizard.phone2.trim().length > 0 &&
      !F.validatePhoneRegix(wizard.phone2)
    ) {
      errors.push("Alternate Phone Number is Invalid");
    }

    if (wizard.email && wizard.email !== "") {
      if (!F.validateEmail(wizard.email)) {
        errors.push("Email address is invalid.");
      }
    }

    // if (wizard.auto_sold_toggle === "") {
    //   errors.push("Auto Policy Sold is Mandatory.");
    // }
    // if (wizard.home_sold_toggle === '') {
    //   errors.push('Home Policy Sold is Mandatory.');
    // }
    if (
      wizard.auto_sold_toggle === "0" &&
      (wizard.auto_policy_not_sold_expiration_date === "" ||
        wizard.auto_policy_not_sold_expiration_date === null)
    ) {
      errors.push("Active Call Date is mandatory.");
    }
    if (
      wizard.home_sold_toggle === "0" &&
      (wizard.home_policy_not_sold_expiration_date === "" ||
        wizard.home_policy_not_sold_expiration_date === null)
    ) {
      errors.push("Active Call Date is mandatory.");
    }
    if (wizard.auto_sold_toggle === "1") {
      if (
        wizard.auto_policy_sold_effective_date === "" ||
        wizard.auto_policy_sold_effective_date === null
      ) {
        errors.push("Active Call Date is mandatory.");
      }
      if (
        wizard.auto_policy_sold_term === "" ||
        wizard.auto_policy_sold_term === null
      ) {
        errors.push("Term is mandatory.");
      }
    }
    if (wizard.home_sold_toggle === "1") {
      if (
        wizard.home_policy_sold_effective_date === "" ||
        wizard.home_policy_sold_effective_date === null
      ) {
        errors.push("Active Call Date is mandatory.");
      }
      if (
        wizard.home_policy_sold_term === "" ||
        wizard.home_policy_sold_term === null
      ) {
        errors.push("Term is mandatory.");
      }
    }
    if (wizard.auto_sold_toggle === "1" || wizard.home_sold_toggle === "1") {
      if (
        wizard.address === "" ||
        wizard.city === "" ||
        wizard.state === "" ||
        wizard.zipcode === ""
      ) {
        errors.push("Address, City, State & Zip Code are mandatory.");
      }
    }
    // if (wizard.cross_sell_policies_uncovered > 0) {
    //   for (var i = 0; i < wizard.policies.length; i++) {
    //     if (
    //       wizard.policies[i].sold === "" ||
    //       wizard.policies[i].sold === null
    //     ) {
    //       errors.push("Cross-Sell are Mandatory.");
    //       break;
    //     }
    //   }
    // }


    if (
      errors &&
      errors.length > 0
    ) {
      message.error(errors[0]);
    }


    // if (errors.length === 0) {
    //   if (wizard.isQuickFollowUpCallFromBFileAction) {
    //     // this.showSendBfileModal();
    //     this.checkDuplicateCustomer(true);
    //   } else {
    //     this.checkDuplicateCustomer(true);
    //   }
    // }
    if (errors.length === 0) {
      this.checkDuplicateCustomer(true);
    }
  }


  updateWizard() {
    const { wizard, user, save } = this.props;

    if (!wizard) return;

    if (!wizard.first_name || !wizard.last_name || !wizard.phone) {
      message.error(PLEASE_FILL_ALL_REQUIRED_FIELD);
      return;
    }


    const inputValue = wizard.phone.replace(/\D/g, '');
    if (inputValue.length !== 10) {
      message.error(PHONE_NUMBER_INVALID);
      return;
    }

    const note_action = "Update B File";
    const userNewNumber = F.removeFormatterFromPhoneNumber(wizard.phone);


    if (userNewNumber !== user.phone) {
      this.checkDuplicateCustomer(false);
    } else {
      save((bfile) => {
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note: note_action,
          user_id: user.id,
          action: note_action,
          type_of_call: wizard.type_of_call,
          sub_type_of_call: wizard.sub_type_of_call
        });
      });
    }
  }


  showSendBfileModal = () => {
    this.setState({ show_send_bfile_modal: true });

    const { wizard, updateField } = this.props;
    updateField("isSentBfile", true)
    updateField("type_of_call", 'FollowUp');
    updateField("sub_type_of_call", 'Thank You / Referrals');
    if (this.props.updateLoadingState != null) this.props.updateLoadingState(true);
    axios.get("/api/agency_associations/" + wizard.agency_id).then((res) => {
      const onboarding_users = [];
      const financial_users = [];
      for (var i = 0; i < res.data.length; i++) {
        let user = res.data[i];
        if (user.user_type === "EA") {
          // onboarding_users.push({
          //     name: user.first_name+" "+user.last_name,
          //     user_type: user.user_type,
          //     id: user.id
          // });
          // F.log("user11", user);
          financial_users.push({
            name: user.first_name + " " + user.last_name,
            user_type: user.user_type,
            id: user.id
          });
        }
        if (user.user_type === "LSP") {
          // if (user.jobs !== null && user.jobs !== "") {
          //   const jobs = JSON.parse(user.jobs);

          // if (jobs.life_licensed) {
          financial_users.push({
            name: user.first_name + " " + user.last_name,
            user_type: user.user_type,
            id: user.id
          });
          // }
          // }
        }
        if (user.user_type === "EFS") {
          financial_users.push({
            name: user.first_name + " " + user.last_name,
            user_type: user.user_type,
            id: user.id
          });
        }
      }
      onboarding_users.push(
        {
          name: "My Internal Team",
          id: "Send For Follow Up"
        },
        {
          name: "B File Team",
          id: "Virtual Onboarder"
        }
      );
      this.setState({
        // loading: false,
        onboarding_users,
        financial_users
        // agent: "Virtual Onboarder",
      });
      if (this.props.updateLoadingState != null) this.props.updateLoadingState(false);
      this.setState({ show_send_bfile_modal: true });

      // this.setVirtualOnBoardersDefault();
    });
  };

  render() {
    // console.log(this.props);
    const {
      wizard,
      updateField,
      submitStep,
      completeAndSubmitExternalBFile,
      save,
      prevStep,
      complete,
      user,
      checkDuplicateCustomer,
    } = this.props;

    const backToProfileClick = () => {
      const wizard = JSON.parse(localStorage.getItem('wizard') || '{}');

      if (!wizard) return;

      const { first_name, last_name, phone, is_saved_for_later, status } = wizard;

      if (!first_name || !last_name || !phone) {
        Modal.confirm({
          title: MANDATORY_FIELDS_ERROR_UPDATION,
          content: DISCARD_UPDATION_CONFIRMATION,
          okText: NO,
          cancelText: YES,
          onOk: () => { },
          onCancel: () => {
            this.props.history.push({
              pathname: `/customer/${this.props.wizard.id}`,
              state: { ...this.props.history.location.state },
            });
          },
        });
        return;
      }


      if (phone) {
        const inputValue = phone.replace(/\D/g, '');
        if (inputValue.length !== 10) {
          message.error('Phone number must be 10 digits.');
          return;
        }
      }


      if (is_saved_for_later === 1 && status === NEW_BFILE) {
        message.success(PROFILE_SAVED_FOR_LATER);
      } else if (is_saved_for_later === 0 && status === RENEWAL) {
        message.success(BFILE_HAS_BEEN_UPDATED);
      } else if (is_saved_for_later === 1 && status === RENEWAL) {
        message.success(PROFILE_SAVED_FOR_LATER);
      } else if (is_saved_for_later === 0 && status === NEW_BFILE) {
        message.success(PROFILE_SAVED_FOR_LATER);
      }


      this.props.history.push({
        pathname: `/customer/${this.props.wizard.id}`,
        state: { ...this.props.history.location.state },
      });
    };


    const isNewProfileSavedForLater = () => {
      const wizard = JSON.parse(localStorage.getItem('wizard') || '{}');
      if (!wizard) {
        return;
      }
      const profileSavedForLater = wizard.is_saved_for_later;

      if (wizard.phone) {
        const inputValue = wizard.phone.replace(/\D/g, '');
        if (inputValue.length != 10) {
          return;
        }
      }

      if (!wizard.first_name || !wizard.last_name || !wizard.phone) {
        return;
      }


      if (profileSavedForLater == 1 && wizard.status == NEW_BFILE) {
        message.success(PROFILE_SAVED_FOR_LATER);
      } else if (profileSavedForLater == 0 && wizard.status == RENEWAL) {
        message.success(BFILE_HAS_BEEN_UPDATED);
      } else if (profileSavedForLater == 1 && wizard.status == RENEWAL) {
        message.success(PROFILE_SAVED_FOR_LATER);
      } else if (profileSavedForLater == 0 && wizard.status == NEW_BFILE) {
        message.success(PROFILE_SAVED_FOR_LATER);
      }
    };


    return (
      <div className="wizardFooter">
        {// `Back to Profile` button will not visible to user If comes from Quick "FollowUp Call" BFile Profile Action
          // !wizard.isQuickFollowUpCallFromBFileAction &&
          //   wizard.id &&
          //   wizard.id !== "" ? (
          //   <div>
          //     {/* <NavLink to={{ pathname: "/customer/" + wizard.id, state: { ...this.props.history.location.state } }}> */}
          //     <Button type="primary" className="buttonNext" style={{ float: "left" }} shape="round"
          //       onClick={backToProfileClick}
          //     >
          //       <Icon type="arrow-left" />
          //       <Translate text={`Back to Profile`} />
          //     </Button>
          //     {/* </NavLink> */}
          //   </div>
          // ) : null
        }

        {wizard.stepIndex === 13 ? (
          <Row className='right'>
            {/* <Button.Group size="large">
                            <Button ghost onClick={() => this.setState({ show_no_sale_archive: true })}>
                                <Translate text={`No Sale/Archive`} />
                            </Button>
                        </Button.Group> */}

            {/* <Button shape="round" onClick={() => window.print()} style={{ color: '#FF5C1C', cursor: 'pointer', fontSize: "calc(14px + (0.2vw - 0.14px))" }}>Download PDF  <img src={PDF} alt="" width={8} /></Button> */}
            <Button shape="round"
              onClick={() => {
                this.setState({ show_print_modal: true });
                isNewProfileSavedForLater();
              }}
              style={{
                color: '#FF5C1C', cursor: 'pointer',
                fontSize: "calc(14px + (0.2vw - 0.14px))"
              }}>
              Download PDF
              <img src={PDF} alt="" width={8} /></Button>

            {wizard.stepIndex > 1 ? (
              <Button type="primary" shape="round" className='buttonNext previous'
                onClick={prevStep.bind(this)}
              >
                <Icon type="left" /> <Translate text={`Previous`} />
              </Button>
            ) : null}

            {wizard.coverage && <Button type="primary" shape="round"
              className='buttonSaveForLater marginTopSm'
              onClick={() => this.handleCompleteClick()}
              style={{
                background: '#FF5C1C', color: 'white',
                marginLeft: 10
              }}
            >
              {

                (wizard.agency_info.is_opportunity == 0)

                  // (
                  //   (wizard.agency_info.review == 0 &&
                  //     wizard.agency_info.vonboard == 0) ||
                  //   (wizard.agency_info.vonboard == 0)
                  // )
                  ? <Translate text="Complete" />
                  : <Translate text="Complete & Submit" />
              }
            </Button>}
            {/* </Button.Group> */}
          </Row>
        ) : (

          <Row className='right'>
            {/* <Row className='right' style={{ marginTop: 20, marginBottom: 20 }}> */}
            {/* <Button.Group size="large">
                            <Button ghost onClick={() => this.setState({ show_no_sale_archive: true })}>
                                <Translate text={`No Sale/Archive`} />
                            </Button>
                        </Button.Group> */}

            {/* {wizard.stepIndex == 1 && (wizard.isQuickFollowUpCallFromBFileAction &&
              !wizard.id ||
              wizard.id === "") && <Button onClick={() =>
                this.setState({ show_save_for_later_modal: true })
              }
                type="primary" shape="round" className='buttonNext previous'>
                Save For Later
              </Button>} */}
            {wizard.stepIndex > 1 ? (
              <Button type="primary" shape="round" className='buttonNext previous'
                onClick={prevStep.bind(this)}
              >
                <Icon type="arrow-left" /> <Translate text={`Previous`} />
              </Button>
            ) : null}

            {/* {wizard.stepIndex > 0 &&
              wizard.id !== "" &&
              !wizard.isQuickFollowUpCallFromBFileAction ? (
              <Button
                type="primary" shape="round" className='buttonNext previous'
                onClick={() => this.updateWizard()}
              >
                <Translate text={`Update B File`} />
              </Button>
            ) : null} */}

            {wizard.stepIndex === 13 && this.props.is_calculator_only ? (
              <Button
                type="primary" shape="round" className='buttonNext'
                onClick={() =>
                  this.setState({ show_send_follow_up_modal: true })
                }
              >
                <Translate text={`Done`} />
              </Button>
            ) : null}

            {wizard.stepIndex === 12 ? (
              !this.props.isExternalBFile ? (
                <Button
                  onClick={() => {
                    complete();
                    submitStep();
                    updateField("coverage", true);
                    updateField("completed_count", 1);
                  }}
                  type="primary"
                  shape="round"
                  className="buttonNext"
                >
                  Calculate Coverage <Icon type="arrow-right" className="iconRight" />
                </Button>
              ) : (
                <Button
                  type="primary"
                  shape="round"
                  className="buttonNext"
                  onClick={submitStep.bind(this, 'finalSubmitExternalBFile')}

                >
                  Complete & Submit <Icon type="arrow-right" className="iconRight" />
                </Button>
              )
            ) : (
              <Button
                onClick={submitStep.bind(this)}
                type="primary"
                shape="round"
                className="buttonNext"
              >
                Next <Icon type="arrow-right" className="iconRight" />
              </Button>
            )}




            {/* <Button.Group size="large">
              <Button
                ghost
                onClick={() =>
                  this.setState({ show_save_for_later_modal: true })
                }
              >
                <Translate text={`Save for Laterj`} />
              </Button>
            </Button.Group> */}
            {/* {wizard.review === 1 ? (
              <Button.Group size="large">
                <Button
                  ghost
                  onClick={() => this.setState({ show_no_answer_modal: true })}
                >
                  <Translate text={`No Answer`} />
                </Button>
              </Button.Group>
            ) : null} */}
            {/* <Button.Group size="large" className="directions">
              {wizard.stepIndex > 1 ? (
                <Button
                  size="large"
                  type="primary"
                  onClick={prevStep.bind(this)}
                >
                  <Icon type="left" /> <Translate text={`Previous`} />
                </Button>
              ) : null} */}
            {/* {wizard.stepIndex > 0 &&
              wizard.id !== "" &&
              !wizard.isQuickFollowUpCallFromBFileAction ? (
                <Button
                  size="large"
                  type="primary"
                  onClick={() => this.updateWizard()}
                >
                  <Translate text={`Update B File`} />
                </Button>
              ) : null} */}
            {/* <Button
                size="large"
                type="primary"
                onClick={submitStep.bind(this)}
                className="next"
              >
                <Translate text={`Next`} /> <Icon type="right" />
              </Button> */}
            {/* </Button.Group> */}
            {/* {wizard.stepIndex === 13 && this.props.is_calculator_only ? (
              <Button.Group size="large">
                <Button
                  type="primary"
                  onClick={() =>
                    this.setState({ show_send_follow_up_modal: true })
                  }
                >
                  <Translate text={`Done`} />
                </Button>
              </Button.Group>
            ) : null} */}
          </Row>
        )
        }

        {/* {
          !this.props.isExternalBFile && (
            <div id="mobilefooter">
              {wizard.stepIndex === 13 ? (
                <Button.Group size="large" className="directions">
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => this.toggleRAC()}
                  >
                    <Icon type="calculator" /> <Translate text={`Intelligence Link`} />
                  </Button>
                  {wizard.stepIndex > 1 ? (
                    <Button
                      size="large"
                      type="primary"
                      onClick={prevStep.bind(this)}
                    >
                      <Icon type="left" />{" "}
                      <span className="lbl">
                        <Translate text={`Previous`} />
                      </span>
                    </Button>
                  ) : null}
                  {wizard.id !== "" ? (
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => this.updateWizard()}
                    >
                      <Icon type="save" /> <Translate text={`Update`} />
                    </Button>
                  ) : null}
                </Button.Group>
              ) : (
                <Button.Group size="large" className="directions">
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => this.toggleRAC()}
                  >
                    <Icon type="calculator" /> <Translate text={`Intelligence Link`} />
                  </Button>
                  {wizard.stepIndex > 1 ? (
                    <Button
                      size="large"
                      type="primary"
                      onClick={prevStep.bind(this)}
                    >
                      <Icon type="left" />{" "}
                      <span className="lbl">
                        <Translate text={`Previous`} />
                      </span>
                    </Button>
                  ) : null}
                  <Button
                    size="large"
                    type="primary"
                    onClick={submitStep.bind(this)}
                    className="next"
                  >
                    <span className="lbl">
                      <Translate text={`Next`} />{" "}
                    </span>
                    <Icon type="arrow-right" />
                  </Button>
                </Button.Group>
              )}
            </div>
          )
        } */}

        {
          wizard.ready ? (
            <div>
              <SendBFileModal
                showModal={this.state.show_send_bfile_modal}
                hideModal={() => {
                  this.setState({ show_send_bfile_modal: false });
                  updateField('type_of_call', wizard.type_of_call_old)
                  updateField('sub_type_of_call', wizard.sub_type_of_call_old)
                  updateField("isSentBfile", false)
                  updateField('expiration_date', wizard.expiration_date_old)
                }}

                wizard={wizard}
                updateField={updateField}
                save={save}
                user={user}
                history={this.props.history}
                financial_users={this.state.financial_users}
                onboarding_users={this.state.onboarding_users}
              />

              <SaveForLaterModal
                showModal={this.state.show_save_for_later_modal}
                hideModal={() =>
                  this.setState({ show_save_for_later_modal: false })
                }
                wizard={wizard}
                updateField={updateField}
                save={save}
                user={user}
                history={this.props.history}
                checkDuplicateCustomer={checkDuplicateCustomer}
              />

              <SendFollowUpModal
                showModal={this.state.show_send_follow_up_modal}
                hideModal={() =>
                  this.setState({ show_send_follow_up_modal: false })
                }
                wizard={wizard}
                updateField={updateField}
                save={save}
                user={user}
                history={this.props.history}
              />

              <NoAnswerModal
                showModal={this.state.show_no_answer_modal}
                hideModal={() => this.setState({ show_no_answer_modal: false })}
                wizard={wizard}
                updateField={updateField}
                save={save}
                user={user}
                history={this.props.history}
              />

              <NoSaleArchiveModal
                showModal={this.state.show_no_sale_archive}
                hideModal={() => this.setState({ show_no_sale_archive: false })}
                wizard={wizard}
                updateField={updateField}
                save={save}
                user={user}
                history={this.props.history}
              />

              <CustomerExist
                showModal={wizard.show_modal_customer_exist}
                ok={(id) => {
                  updateField("show_modal_customer_exist", false);
                  updateField("parent_id", wizard.modal_customer_bfile_id);
                  // updateField("modal_customer_ignore", true);// comment as we don't need It now

                  // redirect to existing cutomer edit Intelligence Link
                  setTimeout(() => {
                    this.props.history.push(
                      "/wizard/step/1/" + wizard.modal_customer_bfile_id
                    );
                    window.location.reload();  // Force a page reload after pushing the new URL
                  }, 200);

                  // new add
                  // setTimeout(() => {
                  //   if (DataHandler.isShowSendingBFileModalState()) {
                  //     this.showSendBfileModal();
                  //   }
                  // }, 100);
                }}
                cancel={() => {
                  updateField("show_modal_customer_exist", false);
                  updateField("parent_id", null);
                  updateField("phone", "")
                  // redirect
                  // setTimeout(
                  //   () =>
                  //     this.props.history.push(
                  //       "/customer/" + wizard.modal_customer_bfile_id
                  //     ),
                  //   200
                  // );
                }}
              />
              <PrintableContent
                ref={this.printRef}
                user={user}
                bfile={wizard}
                agency_owner_details={this.props.agency_owner_details}
                data={{
                  minimum_liability_limits_ext: this.props.minimum_liability_limits_ext,
                  carrier: this.props.carrier,
                }}
              />

              {this.state.show_print_modal &&
                <React.Fragment>
                  {this.printRef.current &&
                    (
                      <HandlePrint contentRef={this.printRef}
                        hideModal={() => {
                          this.setState({ show_print_modal: false })
                        }}
                      />
                    )
                  }
                </React.Fragment>
              }
              {/* <Modal
              title="Alert"
              visible={this.state.showConfirmationModal}
              onOk={() => {
                this.setState({ showConfirmationModal: false }, () => {
                  setTimeout(() => {
                    this.setState({ show_send_bfile_modal: true });
                  }, 100);
                });
              }}
              onCancel={() => {
                this.setState({ showConfirmationModal: false }, () => {
                  this.props.history.push("/dashboard");
                });
              }}
              okText={<Translate text={`Yes`} />}
              cancelText={<Translate text={`No`} />}
            >
              <p>Are you sure you want to add duplicate customer?</p>
            </Modal> */}
            </div>
          ) : null
        }
      </div >
    );
  }
}

export default WizardFooter;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/wizard-footer.js